var map = {
	"./accordion-arrow.svg": 607,
	"./arrow.svg": 608,
	"./bigcommerce-logo.svg": 609,
	"./magento1-logo.svg": 610,
	"./magento2-logo.svg": 611,
	"./opencart-logo.svg": 612,
	"./prestashop-logo.svg": 613,
	"./shopify-logo.svg": 614,
	"./shopware-logo.svg": 615,
	"./trustpilot-logo.svg": 616,
	"./woocommerce-logo.svg": 617
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 606;


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images ^\.\/.*\.svg$
// module id = 606
// module chunks = 0